import {
	factoryReduction,
	handSize1,
	noHandNextSeason,
	noWinterHand,
	recharge1,
	summitCarbonDump,
	takeNeighboringEnergy1,
} from '@lc/const/modifiers';
import { createCardContract } from '@lc/interface/card/contract/factory';

export const ContractMeta = [
	createCardContract(
		7,
		`GIVE CHERNOBYL ANOTHER CHANCE`,
		`BUILD TWO (2) FACTORIES THIS SEASON`,
		`ONE (1) CARBON + COST OF FACTORIES REDUCED BY ONE (1) THIS SEASON`,
		`LOSE TWO (2) FACTORIES`,
		`EVERYONE DESERVES A SECOND CHA-OH GOD WHAT IS THAT THING?!”`,
		factoryReduction
	),
	createCardContract(
		8,
		`BUILD A CARBON FIBER FACTORY IN DUBAI`,
		`BUILD ONE (1) FACTORY ENTIRELY WITH CARBON`,
		`TWO (2) CARBON`,
		`LOSE ONE (1) FACTORY`,
		`“I SNEEZED AND IT ALMOST BLEW OVER.”`
	),
	createCardContract(
		9,
		`PRODUCE ANTI-AEROSOL MUSICAL`,
		`WORLD ENERGY REQUIREMENT MET AT NEXT SUMMIT`,
		`THREE (3) CARBON`,
		`ALL THE CARBON THAT WOULD GO INTO THE WORLD ENERGY POOL THIS SUMMIT GOES INTO YOUR FOOTPRINT INSTEAD`,
		`“THE ONLY THING BETTER THAN HAIRSPRAY IS PROTECTING THE OZONE.”`,
		summitCarbonDump
	),
	createCardContract(
		10,
		`GENERATE AND HIBERNATE`,
		`BUILD ONE (1) FACTORY AND TWO (2) BATTERIES`,
		`COST OF FACTORIES REDUCED BY ONE (1) THIS SEASON`,
		`LOSE ONE (1) FACTORY`,
		`“HIGH-FRUCTOSE ALTERNATIVE ENERGY.”`,
		factoryReduction
	),
	createCardContract(
		11,
		`CREATE A SECRET SOCIETY THAT WORSHIPS TRIANGLES`,
		`HAVE AT LEAST THREE (3) PR`,
		`TWO (2) CARBON`,
		`GIVE A BATTERY TO THE PLAYER ON YOUR RIGHT`,
		`“I HATE TO SOUND OBTUSE, BUT THAT PLEDGE IS ACUTE."`
	),
	createCardContract(
		12,
		`COLLECT COAL FROM BAD CHILDREN’S CHRISTMAS STOCKINGS`,
		`HAVE AT LEAST FOUR (4) PR`,
		`THREE (3) CARBON`,
		`YOU WILL NOT BE DEALT A HAND NEXT SEASON`,
		`“BABY, IT’S COAL OUTSIDE.”`,
		noHandNextSeason
	),
	createCardContract(
		13,
		`GET A TOWN NAMED AFTER YOU WHEN YOU EMPLOY ITS ENTIRE POPULATION`,
		`HAVE AT LEAST SIX (6) PR`,
		`COST OF FACTORIES REDUCED BY ONE (1) THIS SEASON`,
		`LOSE ONE (1) FACTORY`,
		`“IS THAT A STATUE OF... YOU?”`,
		factoryReduction,
		'fall'
	),
	createCardContract(
		14,
		`CREATE A SCHOLARSHIP FUND TO FUND SCHOLARSHIP CREATION`,
		`HAVE AT LEAST SEVEN (7) PR`,
		`COST OF FACTORIES REDUCED BY ONE (1) THIS SEASON`,
		`GIVE A FACTORY TO A NEIGHBORING PLAYER OF YOUR CHOICE`,
		`“THIS SCHOLARSHIP FUND FOR FUNDING SCHOLARSHIPS IS THE FOUNDATION OF FUNDING SCHOLARLY ACTIVITY.”`,
		factoryReduction,
		'fall',
		false,
		true
	),
	createCardContract(
		15,
		`TALK ABOUT HOW YOU CREATED A BATTERY THAT CHARGES ITSELF`,
		`HAVE AT LEAST TWO (2) CHARGED BATTERIES AT THE SUMMIT`,
		`RECHARGE ALL BATTERIES`,
		`LOSE TWO (2) BATTERIES`,
		`“THE ONLY PERPETUAL MOTION IS YOUR YAMMERING.”`,
		``,
		'summer'
	),
	createCardContract(
		16,
		`SAVE SOME ENERGY TO POWER YOUR SICK RC CAR DURING THE SUMMIT`,
		`HAVE THREE (3) CHARGED BATTERIES AT THE NEXT SUMMIT`,
		`COST OF FACTORIES REDUCED BY ONE (1) THIS SEASON`,
		`HAND SIZE REDUCED BY THREE (3) FOR NEXT SEASON`,
		`“WANNA SEE IT DO A WHEELIE?”`,
		factoryReduction
	),
	createCardContract(
		17,
		`USE LIBERAL TEARS TO POWER HYDRO STATION`,
		`HAVE NOT (AND DO NOT) BUY A FACTORY THIS SEASON`,
		`RECHARGE ONE (1) BATTERY AT THE START OF EACH MONTH`,
		`LOSE TWO (2) BATTERIES`,
		`“IT’S ALWAYS RAINING IN PORTLAND.”`,
		recharge1
	),
	createCardContract(
		18,
		`GROUP PROJECT WORKHORSE`,
		`CONTRIBUTE THE MOST THIS SUMMIT`,
		`DRAW THREE (3) CARDS`,
		`ONE (1) CARD HAND NEXT SEASON`,
		`“YOU WILL BE BROKEN DOWN INTO GROUPS OF FOUR, AND ONE OF YOU WILL DO ALL THE WORK.”`,
		handSize1
	),
	createCardContract(
		19,
		`SKIP THE NEXT SUMMIT TO LEARN HOW THE EGYPTIANS MADE THE PYRAMIDS`,
		`DON’T CONTRIBUTE TO THE NEXT SUMMIT`,
		`COST OF FACTORIES IS REDUCED BY ONE (1) THIS SEASON + ONE (1) CARBON`,
		`LOSE ONE (1) FACTORY, GAIN TWO (2) PR`,
		`“ALIENS. IT WAS ALIENS.”`,
		factoryReduction
	),
	createCardContract(
		20,
		`DON’T USE A/C FOR A MONTH`,
		`DON’T CONTRIBUTE THE LEAST THIS SUMMIT`,
		`A PRE-CHARGED BATTERY`,
		`GIVE ONE (1) BATTERY TO EACH OF YOUR NEIGHBORS`,
		`“IT BUILDS CHARACTER.`
	),
	createCardContract(
		21,
		`MAKE A CHARITABLE DONATION`,
		`CONTRIBUTE THE MOST THIS SUMMIT`,
		`TWO (2) CARBON`,
		`EACH PLAYER MAY CHOOSE TO MOVE ONE (1) CARBON FROM THEIR FOOTPRINT TO YOURS`, // change "may" to always do it
		`“THIS IS TAX DEDUCTIBLE? HUH, I HAD NO IDEA...”`
	),
	createCardContract(
		22,
		`ALLOWED TO PUT GREEN LEAF LOGO ON PRODUCT`,
		`HAVE ONE (1) OR FEWER CARBON IN YOUR FOOTPRINT`,
		`ONE (1) CARBON + GAIN TWO (2) PR`,
		`SWITCH CARBON FOOTPRINTS WITH THE PLAYER WITH THE LARGEST CARBON FOOTPRINT`,
		`“HELP YOURSELF TO THE GRANOLA.”SUE OVER AMBIGUOUS`
	),
	createCardContract(
		23,
		`SUE OVER AMBIGUOUS PATENT`,
		`HAVE MORE THAN TWO (2) COLORS OF ENERGY IN YOUR DONATION CUP`,
		`TAKE AN ENERGY FROM A NEIGHBORING PLAYER AT THE START OF EACH MONTH`,
		`NEXT SEASON, DISTRIBUTE YOUR FIRST MONTH’S ENERGY TO THE PLAYERS YOU STOLE FROM`,
		`“I AM NOT A TROLL! SO WHAT IF I LIKE BRIDGES?”`,
		takeNeighboringEnergy1,
		'next',
		true
	),
	createCardContract(
		24,
		`BECOME A DINOSAUR COLLECTOR`,
		`EVERY PLAYER’S COMBINED PR IS GREATER THAN EVERY PLAYER’S COMBINED CARBON FOOTPRINT`,
		`TWO PR (2)`,
		`DIVIDE YOUR PR AMONGST YOUR NEIGHBORS`, // Auto
		`“THIS BELONGS IN A RESERVE!”`,
		``,
		'summer'
	),
	createCardContract(
		25,
		`RAINY DAY FUND HAVE TWO (2) CHARGED`,
		`BATTERIES AT SUMMIT`,
		`ONE (1) BATTERY`,
		`LOSE A BATTERY AND TWO (2) PR`,
		`“ENERGY SAVED IS A BATTERY EARNED.”`
	),
	createCardContract(
		26,
		`GET A HASHTAG TRENDING`,
		`HAVE FIVE (5) PR`,
		`COST OF FACTORIES IS REDUCED BY ONE (1) THIS SEASON`,
		`NEXT SEASON YOUR FACTORIES PRODUCE THE COLOR ENERGY OF A NEIGHBOR OF YOUR CHOICE`,
		`#HASHTAG`,
		factoryReduction,
		'next',
		false,
		true
	),
	createCardContract(
		27,
		`LOBBY GOVERNMENT TO INCREASE FREEZING POINT OF WATER BY 1 DEGREE`,
		`COMPLETE THREE (3) CONTRACTS *NOT* INCLUDING THIS ONE`,
		`STEAL AN INCOMPLETE CONTRACT (AND GET THE FUNDING)`,
		`REMOVE FIVE (5) ENERGY FROM YOUR CUP. THE PLAYER YOU STOLE FROM ADDS FIVE (5) OF THEIR ENERGY TO THEIR CUP`,
		`“RAISE THE WET CEILING.”`,
		``,
		'fall',
		true
	),
	createCardContract(
		28,
		`GET SICK OF WINNING SO MUCH`,
		`HAVE NO FAILED CONTRACTS`,
		`RECHARGE ONE (1) BATTERY PER INCOMPLETE CONTRACT YOUR NEIGHBORS HAVE`,
		`GIVE A FACTORY TO ANOTHER PLAYER`,
		`“CAN’T LOSE IF YOU DON’T COMPETE.”`,
		``,
		'fall',
		false,
		true
	),
	createCardContract(
		29,
		`DO A CENTERFOLD SHOOT OF YOUR ENERGY FOR A SCIENCE MAGAZINE`,
		`WIN TWO (2) AWARDS`,
		`TWO (2) PR`,
		`REMOVE THREE (3) ENERGY FROM YOUR CUP PER FAILED CONTRACT AT THE WINTER SUMMIT *INCLUDING* THIS ONE`,
		`“I JUST READ IT FOR THE ARTICLES.”`,
		``,
		'winter'
	),
	createCardContract(
		// TODO Discard pile activity
		30,
		`AQUIRE PARTS FROM THELOWEST BIDDER`,
		`HAVE TWO (2) PIECES OF EQUIPMENT`,
		`PICK AN EVENT FROM THE DISCARD PILE AND ADD IT TO YOUR HAND`,
		`HAVE NO HAND IN WINTER`,
		`“I’LL BE FINE, WHERE’S THE DUCT TAPE.”`,
		noWinterHand,
		'fall'
	),
];
